import { ROUTES } from "@nf/constants";
import { useTranslation } from "next-i18next";

import SettingsSubscriptionButton from "components/Settings/SettingsSubscriptionButton";

import styles from "./NoSubscriptionsContainer.module.scss";

export const NoSubscriptionsContainer = () => {
  const { t } = useTranslation("translations");
  return (
    <div className={styles.container}>
      <p className={styles.text}>{t("web_subscription_no_subscription")}</p>
      <SettingsSubscriptionButton
        variant="primary"
        href={ROUTES.PAYMENT_SUBSCRIPTION}
      >
        {t("web_subscription_no_subscription_button")}
      </SettingsSubscriptionButton>
    </div>
  );
};

export default NoSubscriptionsContainer;
